import { IDeleteMultipleBaseRequest } from "../../../models/request/base/deleteRequest";
import { IBusTuyenDuongSelectRequest } from "../../../models/request/bus/busBaoCaoDiemDanhRequest";
import { IUploadExcelRequest } from "../../../models/request/bus/uploadExcelRequest";
import { BusLaiXeItemResponse } from "../../../models/response/bus/bus_laixe";
import { BusMonitoringItemResponse } from "../../../models/response/bus/bus_monitoring";
import { bus_tuyenduong, BusTuyenDuongItemResponse } from "../../../models/response/bus/bus_tuyenduong";
import { BusXeItemResponse } from "../../../models/response/bus/bus_xe";
import {
	eBusTuyenDuongActionTypeIds,
	IBusTuyenDuongChangeSelectedIds,
	IBusTuyenDuongCloseConfirm,
	IBusTuyenDuongCloseDetail,
	IBusTuyenDuongCloseImportModal,
	IBusTuyenDuongDeleteErr,
	IBusTuyenDuongDeleteStart,
	IBusTuyenDuongDeleteSuccess,
	IBusTuyenDuongImportErr,
	IBusTuyenDuongImportStart,
	IBusTuyenDuongImportSuccess,
	IBusTuyenDuongLoadErr,
	IBusTuyenDuongLoadLaiXeErr,
	IBusTuyenDuongLoadLaiXeStart,
	IBusTuyenDuongLoadLaiXeSuccess,
	IBusTuyenDuongLoadMonitoringErr,
	IBusTuyenDuongLoadMonitoringStart,
	IBusTuyenDuongLoadMonitoringSuccess,
	IBusTuyenDuongLoadStart,
	IBusTuyenDuongLoadSuccess,
	IBusTuyenDuongLoadXeErr,
	IBusTuyenDuongLoadXeStart,
	IBusTuyenDuongLoadXeSuccess,
	IBusTuyenDuongSaveErr,
	IBusTuyenDuongSaveStart,
	IBusTuyenDuongSaveSuccess,
	IBusTuyenDuongShowConfirm,
	IBusTuyenDuongShowDetail,
	IBusTuyenDuongShowImportModal,
	IBusTuyenDuongValidateImportErr,
	IBusTuyenDuongValidateImportStart,
	IBusTuyenDuongValidateImportSuccess
} from "../../action-types/bus/IBusTuyenDuongActionTypes";

export const busTuyenDuongActions = {
	loadBusTuyenDuongStart: (request: IBusTuyenDuongSelectRequest): IBusTuyenDuongLoadStart => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadBusTuyenDuongSuccess: (data: BusTuyenDuongItemResponse[]): IBusTuyenDuongLoadSuccess => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusTuyenDuongError: (message: string): IBusTuyenDuongLoadErr => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadBusXeStart: (dm_coso_id: number): IBusTuyenDuongLoadXeStart => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_XE_START,
			payload: dm_coso_id
		}
	},
	loadBusXeSuccess: (data: BusXeItemResponse[]): IBusTuyenDuongLoadXeSuccess => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_XE_SUCCESS,
			payload: data
		}
	},
	loadBusXeError: (message: string): IBusTuyenDuongLoadXeErr => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_XE_ERROR,
			payload: message
		}
	},
	loadBusLaiXeStart: (dm_coso_id: number): IBusTuyenDuongLoadLaiXeStart => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_LAIXE_START,
			payload: dm_coso_id
		}
	},
	loadBusLaiXeSuccess: (data: BusLaiXeItemResponse[]): IBusTuyenDuongLoadLaiXeSuccess => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_LAIXE_SUCCESS,
			payload: data
		}
	},
	loadBusLaiXeError: (message: string): IBusTuyenDuongLoadLaiXeErr => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_LAIXE_ERROR,
			payload: message
		}
	},
	loadBusMonitoringStart: (dm_coso_id: number): IBusTuyenDuongLoadMonitoringStart => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_MONITORING_START,
			payload: dm_coso_id
		}
	},
	loadBusMonitoringSuccess: (data: BusMonitoringItemResponse[]): IBusTuyenDuongLoadMonitoringSuccess => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_MONITORING_SUCCESS,
			payload: data
		}
	},
	loadBusMonitoringError: (message: string): IBusTuyenDuongLoadMonitoringErr => {
		return {
			type: eBusTuyenDuongActionTypeIds.LOAD_MONITORING_ERROR,
			payload: message
		}
	},
	showBusTuyenDuongDetail: (data?: BusTuyenDuongItemResponse): IBusTuyenDuongShowDetail => {
		return {
			type: eBusTuyenDuongActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeBusTuyenDuongDetail: (): IBusTuyenDuongCloseDetail => {
		return {
			type: eBusTuyenDuongActionTypeIds.CLOSE_DETAIL
		}
	},
	changeBusTuyenDuongSelectedIds: (ids: number[]): IBusTuyenDuongChangeSelectedIds => {
		return {
			type: eBusTuyenDuongActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showBusTuyenDuongConfirm: (): IBusTuyenDuongShowConfirm => {
		return {
			type: eBusTuyenDuongActionTypeIds.SHOW_CONFIRM
		}
	},
	closeBusTuyenDuongConfirm: (): IBusTuyenDuongCloseConfirm => {
		return {
			type: eBusTuyenDuongActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveBusTuyenDuongStart: (data: bus_tuyenduong): IBusTuyenDuongSaveStart => {
		return {
			type: eBusTuyenDuongActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveBusTuyenDuongSuccess: (is_update: boolean): IBusTuyenDuongSaveSuccess => {
		return {
			type: eBusTuyenDuongActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveBusTuyenDuongError: (message: string): IBusTuyenDuongSaveErr => {
		return {
			type: eBusTuyenDuongActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteBusTuyenDuongStart: (request: IDeleteMultipleBaseRequest): IBusTuyenDuongDeleteStart => {
		return {
			type: eBusTuyenDuongActionTypeIds.DELETE_START,
			payload: request
		}
	},
	deleteBusTuyenDuongSuccess: (): IBusTuyenDuongDeleteSuccess => {
		return {
			type: eBusTuyenDuongActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteBusTuyenDuongError: (message: string): IBusTuyenDuongDeleteErr => {
		return {
			type: eBusTuyenDuongActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	showBusTuyenDuongImportModal: (): IBusTuyenDuongShowImportModal => {
		return {
			type: eBusTuyenDuongActionTypeIds.SHOW_IMPORT_MODAL
		}
	},
	closeBusTuyenDuongImportModal: (): IBusTuyenDuongCloseImportModal => {
		return {
			type: eBusTuyenDuongActionTypeIds.CLOSE_IMPORT_MODAL
		}
	},
	validateImportBusTuyenDuongStart: (request: IUploadExcelRequest): IBusTuyenDuongValidateImportStart => {
		return {
			type: eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_START,
			payload: request
		}
	},
	validateImportBusTuyenDuongSuccess: (data: any[]): IBusTuyenDuongValidateImportSuccess => {
		return {
			type: eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_SUCCESS,
			payload: data
		}
	},
	validateImportBusTuyenDuongError: (message: string): IBusTuyenDuongValidateImportErr => {
		return {
			type: eBusTuyenDuongActionTypeIds.VALIDATE_IMPORT_ERROR,
			payload: message
		}
	},
	importBusTuyenDuongStart: (request: IUploadExcelRequest): IBusTuyenDuongImportStart => {
		return {
			type: eBusTuyenDuongActionTypeIds.IMPORT_START,
			payload: request
		}
	},
	importBusTuyenDuongSuccess: (): IBusTuyenDuongImportSuccess => {
		return {
			type: eBusTuyenDuongActionTypeIds.IMPORT_SUCCESS
		}
	},
	importBusTuyenDuongError: (message: string): IBusTuyenDuongImportErr => {
		return {
			type: eBusTuyenDuongActionTypeIds.IMPORT_ERROR,
			payload: message
		}
	}
}
